import PropTypes from 'prop-types';

export const ShipFromPropType = PropTypes.shape({
  name: PropTypes.string,
  company: PropTypes.string,
  phone: PropTypes.string,
  line1: PropTypes.string,
  line2: PropTypes.string,
  line3: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  postalCode: PropTypes.string,
  countryCode: PropTypes.string,
  residentialIndicator: PropTypes.string,
  shipFromId: PropTypes.string,
});

/**
 * @typedef {object} ShipFromPropType
 * @property {string} name
 * @property {string} company
 * @property {string} phone
 * @property {string} line1
 * @property {string} line2
 * @property {string} line3
 * @property {string} city
 * @property {string} state
 * @property {string} postalCode
 * @property {string} countryCode
 * @property {string} residentialIndicator
 * @property {string} shipFromId
 */
